import { useTheme } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';

function TimesheetEntryStyles() {
    const theme = useTheme();

    return {
        entryRow: {
            [theme.breakpoints.up('md')]: {
                flexWrap: 'nowrap',
            },
            zIndex: 0,
            position: 'relative',
        },
        entryCell: {
            [theme.breakpoints.down('md')]: {
                marginBottom: '12px',
            },
            [theme.breakpoints.up('md')]: {
                '&:first-child': {
                    '& .MuiSelect-outlined': {
                        borderTopLeftRadius: '8px',
                        borderBottomLeftRadius: '8px',
                    },
                },
                '&:nth-child(2)': {
                    '& .MuiSelect-outlined': {
                        borderRight: 'none',
                    },
                },
                '&:nth-child(4)': {
                    '& .MuiInputBase-input': {
                        borderRight: 'none',
                    },
                },
                '&:nth-child(5)': {
                    '& .MuiInputBase-input': {
                        borderRight: 'none',
                    },
                },
                '&:nth-child(7)': {
                    '& .MuiInputBase-input': {
                        borderBottom: `1px solid ${COLORS.LT_MIDNIGHT5}`,
                    },
                },
            },
        },
        menuButtonCell: {
            border: `1px solid ${COLORS.LT_MIDNIGHT5}`,
            padding: '2px',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
            overflow: 'hidden',
            background: COLORS.LT_JOURNEY10,
        },
        mobileMenuButtonCell: {
            width: '100%',
            border: 'unset',
            paddingTop: '0px',
            paddingBottom: '0px',
        },
        copyADayMenu: {
            '& .MuiList-root': {
                padding: '0',
            },
        },
        disabledBackgroundColor: {
            background: COLORS.LT_MIDNIGHTBG2,
        },
        formControl: {
            marginBottom: '0',
            [theme.breakpoints.up('md')]: {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent',
                    borderRadius: '8px',
                },
            },
        },
        formControlOrange: {
            marginBottom: '0',
            [theme.breakpoints.down('lg')]: {
                '& .MuiOutlinedInput-multiline': {
                    '& fieldset': {
                        borderColor: `${COLORS.LT_WARNING} !important`,
                    },
                },
                '& .MuiOutlinedInput-inputMultiline': {
                    borderColor: `${COLORS.LT_WARNING} !important`,
                    borderRadius: '8px',
                },
            },
            [theme.breakpoints.up('md')]: {
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: `${COLORS.LT_WARNING} !important`,
                    },
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: COLORS.LT_WARNING,
                    borderRadius: '8px',
                },
            },
        },
        menuButton: {
            color: COLORS.TRUE_BLUE,
        },
        menuIcon: {
            color: COLORS.LT_MIDNIGHT25,
            display: 'flex',
            alignItems: 'center',
        },
        menuIconRemove: {
            color: COLORS.LT_PEPPER,
        },
        menuIconCallBack: {
            color: COLORS.LT_MIDNIGHT33,
        },
        menuIconBreak: {
            color: COLORS.LT_FOUNDATION,
        },
        expandMore: {
            color: COLORS.LT_MIDNIGHT25,
            height: '20px',
            right: '8px',
            top: 'calc(50% - 10px)',
        },
        inputRoot: {
            '&$disabled $notchedOutline': {
                borderColor: 'transparent',
            },

            '&$disabled $input': {
                background: COLORS.LT_MIDNIGHTBG2,
                color: COLORS.LT_MIDNIGHT33,
            },
        },
        disabled: {},
        notchedOutline: {},
        input: {
            padding: '16px !important',
            height: 'auto',
            fontSize: '14px',
            lineHeight: '20px',
            border: `1px solid ${COLORS.LT_MIDNIGHT5}`,
            [theme.breakpoints.up('md')]: {
                borderRight: 'none',
                '&::placeholder': {
                    opacity: 0,
                },
            },
            '&$disabled': {
                background: COLORS.LT_MIDNIGHTBG2,
            },
            '&[type="time"]': {
                height: '20px',
            },
        },

        selectOutlined: {
            padding: '16px 24px 16px 16px !important',
            fontSize: '14px',
            lineHeight: '20px',
            borderRadius: '0px',
            borderColor: COLORS.LT_MIDNIGHT5,
            border: `1px solid ${COLORS.LT_MIDNIGHT5}`,
            [theme.breakpoints.up('md')]: {
                borderRight: 'none',

                '& .select-placeholder': {
                    opacity: 0,
                },
            },
            '&$disabled': {
                background: COLORS.LT_MIDNIGHTBG2,
                color: COLORS.LT_MIDNIGHT33,
            },
            '& .select-placeholder': {
                color: COLORS.LT_MIDNIGHT33,
            },
        },
        commentsInput: {
            flexGrow: '1',
            maxWidth: '100%',
            [theme.breakpoints.down('sm')]: {
                marginBottom: '8px',
            },
        },
        mobileMenuButton: {
            display: 'none',
        },
        entryContainer: {
            flexWrap: 'nowrap',
            [theme.breakpoints.down('md')]: {
                backgroundColor: COLORS.LT_MIDNIGHT10,
                padding: '1.5rem',
                borderRadius: '.75rem',
            },
        },
        midCallBackConnector: {
            position: 'absolute',
            height: '35px',
            width: '600px',
            borderRight: '1px solid #EEF0F1',
            right: '28px',
            borderBottom: '1px solid #EEF0F1',
            bottom: '52%',
            zIndex: -1,
        },
        endCallBackConnector: {
            position: 'absolute',
            height: '6em',
            borderRight: '1px solid #EEF0F1',
            right: '28px',
            borderBottom: '1px solid #EEF0F1',
            bottom: '0%',
            zIndex: -1,
        },
        midCallBackConnectorContainer: {
            height: '3.5em',
            width: '3.5em',
            position: 'relative',
        },
        connectorGrid: {
            zIndex: -1,
            backgroundColor: COLORS.WHITE,
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
        endCallBackConnectorContainer: {
            height: '4em',
            position: 'absolute',
            right: '0%',
        },
        menuGrid: {
            backgroundColor: COLORS.WHITE,
            zIndex: 1,
        },
        mobileMenuGrid: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        endRowContainer: {
            flexWrap: 'nowrap',
        },
        shiftMobileHeader: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            [theme.breakpoints.down('md')]: {
                color: COLORS.LT_JOURNEY,
            },
        },
        inputLabel: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            [theme.breakpoints.down('md')]: {
                color: COLORS.RAVEN,
            },
        },
        callWithCallbackEntry: {
            [theme.breakpoints.down('md')]: {
                paddingBottom: '0px !important',
            },
        },
        callbackEntry: {
            [theme.breakpoints.down('md')]: {
                paddingBottom: '0px !important',
                paddingTop: '0px !important',
            },
        },
        lastCallbackEntry: {
            [theme.breakpoints.down('md')]: {
                paddingTop: '0px !important',
            },
        },
        callWithCallbackEntryContainer: {
            flexWrap: 'nowrap',
            [theme.breakpoints.down('md')]: {
                backgroundColor: COLORS.LT_MIDNIGHT10,
                padding: '1.5rem 1.5rem .5rem 1.5rem',
                borderRadius: '.75rem .75rem 0 0',
            },
        },
        callbackEntryContainer: {
            flexWrap: 'nowrap',
            [theme.breakpoints.down('md')]: {
                backgroundColor: COLORS.LT_MIDNIGHT10,
                padding: '0 1.5rem .5rem 1.5rem',
                borderRadius: '0',
            },
        },
        lastCallbackEntryContainer: {
            flexWrap: 'nowrap',
            [theme.breakpoints.down('md')]: {
                backgroundColor: COLORS.LT_MIDNIGHT10,
                padding: '0 1.5rem 1.5rem 1.5rem',
                borderRadius: '0 0 .75rem .75rem',
            },
        },
        callbackMobileHeader: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        callbackMobileHeaderText: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            [theme.breakpoints.down('md')]: {
                color: COLORS.LT_JOURNEY,
                marginTop: '12px',
            },
        },
        shiftDeleteButton: {
            width: '100%',
            background: COLORS.LT_PEPPER,
            color: 'white',
            marginTop: '8px',
        },
        callbackDeleteButton: {
            width: '100%',
            marginBottom: '4px',
        },
        shiftActionButton: {
            width: '100%',
            background: COLORS.LT_JOURNEY,
            color: 'white',
        },
        shiftWithChildActionButton: {
            width: '100%',
            background: COLORS.LT_JOURNEY,
            color: 'white',
            marginTop: '16px',
        },
        actionRemoveShiftButton: {
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
    };
}

export default TimesheetEntryStyles;
